import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Avatar,
  Box,
  Divider,
  Grid,
  Paper,
  Stack,
  Tab,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget } from '../../../../widgets';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { setActivoEquiposAction } from '../../equipos/EquiposAction';
import EquiposJuegosView from '../../equipos_juegos/EquiposJuegosView';
import { setActivoJuegosAction } from '../../juegos/JuegosAction';
import JuegosView from '../../juegos/JuegosView';
import RondasView from '../../rondas/RondasView';
import GraficoResultadosComponent from './components/GraficoResultados';

const PanelTorneosView = () => {
  const dispatch = Redux.useDispatch();

  const torneosStore = Redux.useSelector((state) => state.torneos);

  const activo = torneosStore.activo;

  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    setActivoJuegosAction(dispatch, null);
    setActivoEquiposAction(dispatch, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={torneosStore.loadingAll}
          text={'Cargando datos...'}
        />
      </Grid>
      <Grid item md={4}>
        <Stack direction="column" spacing={1}>
          <Paper elevation={4}>
            <Grid container spacing={0}>
              <Grid item xs={12} md={12} align="center">
                <Avatar
                  alt={activo.imagen?.pnombre}
                  sx={{ width: 150, height: 150, my: 2 }}
                  src={getFilesArchivos(activo.imagen?.avatar)}
                />
              </Grid>
              <Grid item xs={12} md={12} align="center">
                <Typography variant="h6">{activo.nombre}</Typography>
              </Grid>
              <Grid item xs={12} md={12} align="center">
                <Divider textAlign="left">Detalles</Divider>
              </Grid>
              <Grid item xs={12} md={12} sx={{ p: 2 }}>
                <Grid container spacing={0}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Deporte: </strong>
                      {activo.deporte.nombre}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Cantidad de equipos: </strong>
                      {activo.equipos}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Fecha de inicio: </strong>
                      {activo.fecha}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Stack>
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                <Tab label="Rondas" value="1" />
                <Tab label="Juegos" value="2" />
                <Tab label="Equipos" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ p: 0 }}>
              <RondasView />
            </TabPanel>
            <TabPanel value="2" sx={{ p: 0 }}>
              <JuegosView />
            </TabPanel>
            <TabPanel value="3" sx={{ p: 0 }}>
              <EquiposJuegosView />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>
      <Grid item md={12}>
        <Typography variant="h6" color="initial">
          TABLERO DE RESULTADOS
        </Typography>
        <Paper elevation={4} sx={{ mt: 2 }}>
          <GraficoResultadosComponent isAdd={false} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PanelTorneosView;
